import React from 'react';
import { IconButton } from '@mui/material';
import Icon from '../../icons/Icon';
import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import clsx from 'clsx';

import scss from './CommonIconButton.module.scss';

const CommonIconButton = ({
  icon,
  color = 'inherit',
  size,
  onClick,
  isStrokeIcon,
  disabled,
  tooltip,
  ariaLabel,
  iconClassName,
}) => {
  const accessibleName = ariaLabel || tooltip;

  return (
    <StyledTooltip title={tooltip} placement='top' disableInteractive arrow>
      <span className={clsx(disabled && scss.iconButtonWrapper_disabled)}>
        <IconButton
          onClick={onClick}
          color={color}
          size={size}
          disabled={disabled}
          aria-label={accessibleName}
          classes={{ root: scss.iconButton }}>
          <Icon
            icon={icon}
            disableCommonColors
            className={clsx(iconClassName, isStrokeIcon ? scss.strokeIcon : scss.fillIcon)}
          />
        </IconButton>
      </span>
    </StyledTooltip>
  );
};

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
    maxWidth: 'unset',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '-8px',
  },
});

export default CommonIconButton;
